import { ColorTokens, FontFamilyTokens, FontSizeTokens, SizeTypeTokens, } from '@voltmoney/schema';
import React, { memo, useState } from 'react';
import { Pressable, ScrollView, StyleSheet, View, } from 'react-native';
import Typography from '../typography/Typography';
import ThemeProvider from '@voltmoney/theme';
import { Space } from "../space/Space";
const TabDefault = ({ options = [], components, action, triggerAction, widgetItems, renderItem, customWidth, active = 0, doNotNeedScroll }) => {
    const [activeTab, setActiveTab] = useState(active);
    const theme = ThemeProvider.getTheme();
    const colorMapping = theme.colors;
    const borderRadiusMapping = theme.borderRadius;
    const fontFamilyMapping = theme.fontFamily;
    const styles = StyleSheet.create({
        menuBar: {
            flex: 1,
            flexDirection: 'row',
            width: customWidth ? customWidth : '100%',
        },
        children: {
            paddingVertical: 12,
            width: '100%',
            flexGrow: 1
        },
        buttonCommonStyle: {
            paddingBottom: 10,
        },
        buttonItemFirst: {
            flexGrow: 1,
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: colorMapping[ColorTokens.White],
            borderBottomWidth: 1,
            borderColor: colorMapping[ColorTokens.Grey_Chalk],
            paddingBottom: 10,
        },
        buttonItemMiddle: {
            flexGrow: 1,
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: colorMapping[ColorTokens.White],
            //borderTopWidth: 1,
            borderBottomWidth: 1,
            borderColor: colorMapping[ColorTokens.Grey_Chalk],
            //paddingTop: 8,
            paddingBottom: 10,
        },
        buttonItemLast: {
            flexGrow: 1,
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: colorMapping[ColorTokens.White],
            borderBottomWidth: 1,
            borderColor: colorMapping[ColorTokens.Grey_Chalk],
            paddingBottom: 10,
        },
        buttonLabel: {
            fontFamily: fontFamilyMapping[FontFamilyTokens.Inter],
        },
        buttonItemFirstSelected: {
            flexGrow: 1,
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: colorMapping[ColorTokens.White],
            borderBottomWidth: 1,
            borderColor: colorMapping[ColorTokens.Primary_100],
            paddingBottom: 10,
        },
        buttonItemMiddleSelected: {
            flexGrow: 1,
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: colorMapping[ColorTokens.White],
            borderBottomWidth: 1,
            borderColor: colorMapping[ColorTokens.Primary_100],
            paddingBottom: 10,
        },
        buttonItemLastSelected: {
            flexGrow: 1,
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: colorMapping[ColorTokens.White],
            borderBottomWidth: 1,
            borderColor: colorMapping[ColorTokens.Primary_100],
            paddingBottom: 10,
        },
    });
    const getStylesButtonItem = (index, optionsLength) => {
        if (index === 0) {
            return !(activeTab === index)
                ? styles.buttonItemFirst
                : styles.buttonItemFirstSelected;
        }
        else if (index === optionsLength - 1) {
            return !(activeTab === index)
                ? styles.buttonItemLast
                : styles.buttonItemLastSelected;
        }
        else {
            return !(activeTab === index)
                ? styles.buttonItemLast
                : styles.buttonItemLastSelected;
        }
    };
    const handleAction = async (value) => {
        setActiveTab(value);
        if (action && triggerAction) {
            await triggerAction({
                ...action,
                payload: {
                    ...action.payload,
                    value: value,
                },
            });
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(View, { style: styles.menuBar }, options?.map(({ label, disabled }, i) => {
            return (React.createElement(Pressable, { key: `${label}`, style: getStylesButtonItem(i, options.length), onPress: () => handleAction(i) },
                React.createElement(Typography, { label: label, fontSize: FontSizeTokens.SM, lineHeight: 24, fontWeight: i === activeTab ? '600' : '400', fontFamily: FontFamilyTokens.Inter, color: i === activeTab
                        ? ColorTokens.Primary_100
                        : ColorTokens.Grey_Charcoal }),
                React.createElement(Space, { size: SizeTypeTokens.MD })));
        })),
        doNotNeedScroll ? React.createElement(View, { style: styles.children }, renderItem &&
            renderItem(widgetItems[activeTab])) :
            React.createElement(ScrollView, { style: styles.children }, renderItem &&
                renderItem(widgetItems[activeTab]))));
};
export default memo(TabDefault);
export { TabDefault };
